const BASE_URL = "https://amiapp.dpdc.org.bd"; 
const OAUTH_BASE_URL = BASE_URL + "/auth/";
const ADMIN_BASE_URL = BASE_URL + "/admin/";
const ASSEST_MANAGER_URL = BASE_URL + "/assets/";
const BASE_TENANT_CODE = "DPDC";
const ROCKET_CHAT_WIDGET = BASE_URL + "/assets/mitr/";
const ADMIN_SERVICE_BASE_URL = BASE_URL + "/admin/admin-service";
const USAGE_SERVICE_BASE_URL = BASE_URL + "/usage/usage-service";
const CLIENT_ID_KEYCLOCK = "auth-ui";
const AUTH_UI_CLIENT_SECRET_KEYCLOCK = "0yFsAl4nN9jX1GGkgOrvpUxDarf2DT40";
const PAYMENT_URL = "GATEWAY_URL"; 
const BILL_PAY_URL = BASE_URL+"/usage/billpay";
const COMMUNICATION_SERVICE_BASE_URL = BASE_URL + "/communication/communication-service";
const RECPATCHA_SITE_KEY= "6LeRAUglAAAAALbFayG0MTSrIa6baTr8zvkxPZG8";
const RAZORPAY_URL="https://checkout.razorpay.com/v1/checkout.js";
const RAZORPAY_KEY="rzp_test_dtRg3HFLmfZtiP";
const AUTH_TOKEN="gzUmMztcXwR3P8YMYVZJ";

const constants = {
  urls: {
    SEARCH: ADMIN_BASE_URL+"globalsearch",
    LOGIN: OAUTH_BASE_URL + "login",
    ROCKET_CHAT_WIDGET,
    LOGIN_VIA_OTP: OAUTH_BASE_URL + "login/userName",
    LOGOUT: OAUTH_BASE_URL + "login/signout",
    SIGNUP: OAUTH_BASE_URL + "user/create",
    USER:OAUTH_BASE_URL+"user/",
    RESET: OAUTH_BASE_URL + "login/reset-password",
    RESETFORM: OAUTH_BASE_URL + "login/update-password",
    FORGOT_PASSWORD: OAUTH_BASE_URL + "login/forgot-password",
    LOGIN_SENDOTP: OAUTH_BASE_URL + "login/otp/send",
    REFRESH_BEARER: OAUTH_BASE_URL + "login/refresh",
    GENERATE_BEARER: OAUTH_BASE_URL + "login/generate-bearer",
    VALIDATEOTP: OAUTH_BASE_URL + "otp/validate",
    LOGIN_RESENDOTP: OAUTH_BASE_URL + "otp/resend",
    SIGNUP_SENDOTP: OAUTH_BASE_URL + "user/otp/send",
    SIGNUP_VALIDATEOTP: OAUTH_BASE_URL + "user/otp/validate",
    SIGNUP_RESENDOTP: OAUTH_BASE_URL + "otp/resend",
    MIGRATE_USER: OAUTH_BASE_URL + "user/migrateUsers",
    UPLOAD_USER: OAUTH_BASE_URL + "user/upload",
    REETRY_SMS_EMAIL: OAUTH_BASE_URL + "user/retry-email-sms",
    NEW_USER_SMS: OAUTH_BASE_URL + "user/new-user-sms",
    MAIN_APP: BASE_URL + "/",
    LABELS: ADMIN_BASE_URL + "labels/" + BASE_TENANT_CODE,
    PARAMETER_WIDGET_CONTROL:
      ADMIN_BASE_URL + "parameter-controller/" + BASE_TENANT_CODE,
    ASSEST_CODE_API: ADMIN_BASE_URL + "assets/" + BASE_TENANT_CODE + "/",
    ASSEST_URL_ENDPOINT: ASSEST_MANAGER_URL,
    ADMIN_SERVICE_BASE_URL: ADMIN_SERVICE_BASE_URL,
    USAGE_SERVICE_BASE_URL: USAGE_SERVICE_BASE_URL,
    PAYMENT_URL,
    RESEND_EMAIL: OAUTH_BASE_URL + "/auth-service",
    PREMISES: OAUTH_BASE_URL + "auth-service",
    BILL_PAY_PRE_PAYMENT:BILL_PAY_URL+"/prepayment-processing-bill-pay",
    BILL_PAY_POST_PAYMENT: BILL_PAY_URL+"/postpayment-processing-bill-pay",
    USERCHECK:OAUTH_BASE_URL+"user/check-username",
    AUTH_SERVICE: OAUTH_BASE_URL + "auth-service",
    BASE_URL,
    COMMUNICATION_SERVICE_BASE_URL:COMMUNICATION_SERVICE_BASE_URL,
    NEW_USER_SEND_OTP: OAUTH_BASE_URL + "otp/newUserSendOtp",
    NEW_USER_VALIDATE_OTP: OAUTH_BASE_URL + "otp/newUserValidateOtp",
    AUTH_TOKEN:AUTH_TOKEN
  },
  razorpay:{
    RAZORPAY_URL,
    RAZORPAY_KEY
  },
  parameters: {
    TENANT_CODE: BASE_TENANT_CODE,
    I18_CACHE_EXPIRY_TIME: "60000",
    DPDC_PHONE_PREFIX:"0"
  },
  recaptcha:{
    SITE_KEY:RECPATCHA_SITE_KEY,
    SITE_URL:`https://www.google.com/recaptcha/api.js?render=${RECPATCHA_SITE_KEY}&badge=bottomleft`
  },
  confidentialClient:{
    CLIENT_ID_KEYCLOCK,
    AUTH_UI_CLIENT_SECRET_KEYCLOCK
  },
  quickpayConstants: {
    INTERNAL_ERR_MSG_LABEL_KEY: 'E_INTERNAL_ERROR_MESSAGE',
    INVALID_ACC_ID_LABEL_KEY: 'E_INVALID_IDENTIFIER_ERROR_MESSAGE'
  },
  BKASH_PAYMENT_PRECHARGE_API_SUCCESS_RESULT_CODE: "99933" 
};

export const config = constants;